<ng-container *ngIf="useNewIndicator$ | async; else bespokeDot">
  <app-cw-robot-status-dot
    [projectId]="projectId"
    [callsign]="callsign"
    [size]="size"
    [dark]="dark"
  ></app-cw-robot-status-dot>
</ng-container>

<ng-template #bespokeDot>
  <ng-container *ngIf="status !== 'unknown'">
    <app-status-dot [status]="status" [size]="size" [dark]="dark" appTestID="robot-status-dot"></app-status-dot>
  </ng-container>
  <ng-container *ngIf="status === 'unknown'">
    <div class="center-spinner">
      <app-loading-spinner [isLoading]="true"></app-loading-spinner>
    </div>
  </ng-container>
</ng-template>
